module.exports = __webpack_public_path__ + "static/img/7.c20fa3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/7.jpg
// module id = JDKP
// module chunks = 1